var _defs, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.56,
    y1: 21.96,
    x2: 39.2,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.53,
    y1: 42.95,
    x2: 25.47,
    y2: 48.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4286ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4286ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 29.53,
    y1: 42.95,
    x2: 32.47,
    y2: 48.05,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 36.53,
    y1: 42.95,
    x2: 39.47,
    y2: 48.05,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,31.5l-.32,0a10.49,10.49,0,0,0-19.11-8,7,7,0,0,0-10.57,6,7.21,7.21,0,0,0,.1,1.14A7.5,7.5,0,0,0,18,45.5a4.19,4.19,0,0,0,.5,0v0h28a7,7,0,0,0,0-14Z",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#a)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.39,
    y1: 43.03,
    x2: 23.61,
    y2: 47.97,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#b)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "1 -5; -2 10",
    dur: "0.7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31.39,
    y1: 43.03,
    x2: 30.61,
    y2: 47.97,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#c)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.4s",
    type: "translate",
    values: "1 -5; -2 10",
    dur: "0.7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.4s",
    values: "0;1;1;0",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.39,
    y1: 43.03,
    x2: 37.61,
    y2: 47.97,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#d)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.2s",
    type: "translate",
    values: "1 -5; -2 10",
    dur: "0.7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.2s",
    values: "0;1;1;0",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.0dc8335e1b7493bf52c61f083041a541.svg";
export { ForwardRef as ReactComponent };